import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';
import { SEOHead, SEO_PAGES } from '../seo/SEOHead';

export const TermsPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <SEOHead {...SEO_PAGES.terms} />
      <Paper sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 700 }}>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Last updated: January 2026
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ '& h5': { mt: 4, mb: 2, fontWeight: 600 }, '& p': { mb: 2 } }}>
          <Typography variant="h5">1. Acceptance of Terms</Typography>
          <Typography>
            By accessing or using GovToolsPro ("Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.
          </Typography>

          <Typography variant="h5">2. Description of Service</Typography>
          <Typography>
            GovToolsPro is a Chrome browser extension that provides analytics and insights for government contracting opportunities listed on SAM.gov. The Service analyzes publicly available data to help users make informed business decisions.
          </Typography>

          <Typography variant="h5">3. Disclaimer of Accuracy</Typography>
          <Typography sx={{ bgcolor: 'warning.light', p: 2, borderRadius: 1 }}>
            <strong>IMPORTANT:</strong> GovToolsPro provides analytics based on publicly available government data sources including SAM.gov, USAspending.gov, and FPDS.gov. Information presented is for informational purposes only and may not be accurate, complete, or current. Users are solely responsible for conducting their own due diligence before making any business decisions. GovToolsPro is not affiliated with any government agency and is not responsible for inaccurate or incomplete data.
          </Typography>

          <Typography variant="h5">4. User Responsibilities</Typography>
          <Typography>
            You are responsible for:
          </Typography>
          <Typography component="div">
            • Verifying all information independently before making business decisions<br />
            • Maintaining the confidentiality of your account credentials<br />
            • All activities that occur under your account<br />
            • Complying with all applicable laws and regulations<br />
            • Using the Service only for lawful purposes
          </Typography>

          <Typography variant="h5">5. Prohibited Uses</Typography>
          <Typography>
            You may not:
          </Typography>
          <Typography component="div">
            • Use the Service for any illegal purpose<br />
            • Attempt to gain unauthorized access to our systems<br />
            • Interfere with or disrupt the Service<br />
            • Reverse engineer or attempt to extract source code<br />
            • Resell or redistribute the Service without authorization<br />
            • Use automated systems to scrape or collect data
          </Typography>

          <Typography variant="h5">6. Intellectual Property</Typography>
          <Typography>
            The Service and its original content, features, and functionality are owned by GovToolsPro and are protected by international copyright, trademark, and other intellectual property laws.
          </Typography>

          <Typography variant="h5">7. Limitation of Liability</Typography>
          <Typography>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, GOVTOOLSPRO SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR USE OF THE SERVICE.
          </Typography>

          <Typography variant="h5">8. No Government Affiliation</Typography>
          <Typography>
            GovToolsPro is an independent, privately-owned service and is NOT affiliated with, endorsed by, sponsored by, or officially connected with any United States government agency or department, including SAM.gov, USAspending.gov, FPDS.gov, or any other government entity.
          </Typography>

          <Typography variant="h5">9. Subscription and Payments</Typography>
          <Typography>
            Certain features may require a paid subscription. Subscription terms, pricing, and billing details will be provided at the time of purchase. You may cancel your subscription at any time.
          </Typography>

          <Typography variant="h5">10. Termination</Typography>
          <Typography>
            We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
          </Typography>

          <Typography variant="h5">11. Changes to Terms</Typography>
          <Typography>
            We reserve the right to modify these Terms at any time. We will provide notice of significant changes by updating the "Last updated" date. Continued use of the Service after changes constitutes acceptance of the new Terms.
          </Typography>

          <Typography variant="h5">12. Governing Law</Typography>
          <Typography>
            These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
          </Typography>

          <Typography variant="h5">13. Contact Us</Typography>
          <Typography>
            If you have questions about these Terms, please contact us at:
          </Typography>
          <Typography>
            Email: support@govtoolspro.com
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};
